export default __webpack_public_path__ + "static/media/logo-icon.51de0b3f.svg";